/**
 * Blush + eyeshadow palettes spanning Very Fair → Very Deep.
 * Hex lists must stay in sync with backend/shared/color_utils.py.
 */

/** Soft pinks/peaches for fair–light; terracotta/berry for tan–deep. */
export const blushColors = [
  { name: 'Blush Soft Pink', hex: '#F7AFC1' },
  { name: 'Blush Peach', hex: '#F2B28F' },
  { name: 'Blush Strawberry', hex: '#E8BAAA' },
  { name: 'Blush Mauvette', hex: '#C4A0AE' },
  { name: 'Blush Pretty Naked', hex: '#D5B190' },
  { name: 'Blush Healthy', hex: '#D28868' },
  { name: 'Blush Berry', hex: '#A6525B' },
  { name: 'Blush Pink Plum', hex: '#CD8A95' },
  { name: 'Blush Cherry', hex: '#F0648A' },
  { name: 'Blush Plum', hex: '#B14D7A' },
  { name: 'Blush Cranberry', hex: '#B8405A' },
  { name: 'Blush Sugar Plum', hex: '#8F4C63' },
  { name: 'Blush Grapefruit', hex: '#FF7BA3' },
  // Deeper / warmer additions for Medium-Tan → Very Deep
  { name: 'Blush Terracotta', hex: '#C45C3A' },
  { name: 'Blush Burnt Rose', hex: '#A04848' },
  { name: 'Blush Brick', hex: '#8B3A2F' },
  { name: 'Blush Copper Flush', hex: '#B86B4A' },
  { name: 'Blush Deep Berry', hex: '#6E2C3C' },
  { name: 'Blush Cocoa Rose', hex: '#5A2A30' },
  { name: 'Warm Rose', hex: '#C97B6A' },
];

/**
 * Eyeshadow: soft taupes for fair skin + bronze/espresso for deep skin
 * (not limited to blush pinks).
 */
export const eyeshadowColors = [
  { name: 'Eyeshadow Soft Taupe', hex: '#C4A890' },
  { name: 'Eyeshadow Warm Sand', hex: '#D5B190' },
  { name: 'Eyeshadow Peach Nude', hex: '#E0A878' },
  { name: 'Eyeshadow Soft Pink', hex: '#E8BAAA' },
  { name: 'Eyeshadow Mauvette', hex: '#C4A0AE' },
  { name: 'Eyeshadow Rosewood', hex: '#A89080' },
  { name: 'Eyeshadow Copper', hex: '#A67C52' },
  { name: 'Eyeshadow Bronze', hex: '#8B5A2B' },
  { name: 'Eyeshadow Terracotta', hex: '#C55A3A' },
  { name: 'Eyeshadow Warm Brown', hex: '#6B4E3D' },
  { name: 'Eyeshadow Espresso', hex: '#5A3A2E' },
  { name: 'Eyeshadow Soft Plum', hex: '#8F4C63' },
  { name: 'Eyeshadow Berry Smoke', hex: '#A6525B' },
  { name: 'Eyeshadow Deep Plum', hex: '#4A3050' },
  { name: 'Eyeshadow Smoky Taupe', hex: '#6B5A4E' },
  { name: 'Eyeshadow Charcoal Brown', hex: '#3A2A22' },
  { name: 'Eyeshadow Gold Dust', hex: '#C9A050' },
  { name: 'Gold Copper', hex: '#B8860B' },
  { name: 'Eyeshadow Deep Cocoa', hex: '#3F291A' },
];
